import React from 'react'
import Visual from './Visual'

export default function Projects({ projects, lang, t }) {
  return (
    <section className="section" id="projects">
      <div className="container">
        <div className="section-head">
          <div>
            <p className="eyebrow">{t.featured}</p>
            <p>{t.featuredSub}</p>
          </div>
        </div>

        <div className="project-grid">
          {projects.map((p) => (
            <article className="project" key={p.id}>
              <Visual type={p.visual} />

              <div className="project-info">
                <h3>{p.title}</h3>

                <span className="project-category">{p.category[lang]}</span>

                <p>{p.description[lang]}</p>

                <small className="project-stack">{p.stack}</small>

                {p.urls ? (
                  <div className="project-links">
                    {p.urls.map((url, index) => (
                      <a
                        key={url}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                      >
                        <span>
                          {p.id === 'doxi'
                            ? index === 0
                              ? 'Pizza Hut Bolivia'
                              : 'Café Martínez Argentina'
                            : t.viewProject}
                        </span>

                        <b>↗</b>
                      </a>
                    ))}
                  </div>
                ) : p.url ? (
                  <a
                    className="project-link"
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{t.viewProject}</span>
                    <b>↗</b>
                  </a>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
